export default function getQPArrayValue(value: string): Array<string> {
  if (!value) return []
  return value.split(',').filter(Boolean)
}